export const BASENAME = ''; // don't add '/' at end off BASENAME
export const BASE_URL = '/app/admin/solicitudes/dashboard';
export const BASE_URL_USER = '/app/user/solicitudes';
export const BASE_TITLE = ' | FCF Gestió ';
//export const API_SERVER = 'http://localhost:5000/api/';
export const API_SERVER = 'https://dev-backend.fcf.services/';

// URLs Base según entorno para solicitudes-compra (apuntando a dev-backend)
export const SOLICITUDES_COMPRA_URLS = {
    dev: 'https://dev-backend.fcf.services/solicitudes-compra',
    staging: 'https://dev-backend.fcf.services/solicitudes-compra',
    prod: 'https://dev-backend.fcf.services/solicitudes-compra'
};

export const getSolicitudesCompraBaseUrl = () => {
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        if (hostname.includes('staging')) {
            return SOLICITUDES_COMPRA_URLS.staging;
        }
        if (hostname === 'gestio.fcf.cat' || hostname === 'backend.fcf.services') {
            return SOLICITUDES_COMPRA_URLS.prod;
        }
    }
    return SOLICITUDES_COMPRA_URLS.dev;
};

export const SOLICITUDES_COMPRA_API = getSolicitudesCompraBaseUrl();

// Endpoints de proveedores integrados en solicitudes-compra
export const PROVEEDORES_API = {
    getAll: `${SOLICITUDES_COMPRA_API}/proveedores/get-all`,
    list: `${SOLICITUDES_COMPRA_API}/proveedores`,
    create: `${SOLICITUDES_COMPRA_API}/proveedores`,
    createLegacy: `${SOLICITUDES_COMPRA_API}/proveedores/new`,
    update: `${SOLICITUDES_COMPRA_API}/proveedores/update`,
    updatePut: (id) => id ? `${SOLICITUDES_COMPRA_API}/proveedores/${id}` : `${SOLICITUDES_COMPRA_API}/proveedores`,
    delete: `${SOLICITUDES_COMPRA_API}/proveedores/delete`,
    deleteById: (id) => `${SOLICITUDES_COMPRA_API}/proveedores/${id}`,
};

// URLs Base según entorno para control_stock
export const STOCK_URLS = {
    dev: 'https://dev-backend.fcf.services/stock',
    staging: 'https://dev-backend.fcf.services/stock',
    prod: 'https://dev-backend.fcf.services/stock'
};

export const getStockBaseUrl = () => {
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        if (hostname.includes('staging')) {
            return STOCK_URLS.staging;
        }
        if (hostname === 'gestio.fcf.cat' || hostname === 'backend.fcf.services') {
            return STOCK_URLS.prod;
        }
    }
    return STOCK_URLS.dev;
};

export const STOCK_API = getStockBaseUrl();

// Endpoints de productos en control_stock
export const PRODUCTOS_API = {
    list: (page = 1) => `${STOCK_API}/products/${page}`,
    all: `${STOCK_API}/products/all`,
    base: `${STOCK_API}/products`,
    single: (id) => `${STOCK_API}/product/${id}`,
    create: `${STOCK_API}/product`,
    update: `${STOCK_API}/product`,
    delete: (id) => `${STOCK_API}/product/${id}`
};

// Otros recursos de control_stock
export const STOCK_ENDPOINTS = {
    categorias: `${STOCK_API}/categorias`,
    zonas: `${STOCK_API}/zonas`,
    ubicaciones: `${STOCK_API}/ubicaciones`,
    resumen: `${STOCK_API}/resumen`
};

// Endpoints de transacciones en control_stock
export const TRANSACCIONES_API = {
    list: (page = 1) => `${STOCK_API}/transacciones/${page}`,
    create: `${STOCK_API}/transaccion`,
    update: `${STOCK_API}/transaccion`,
    byProduct: (idProducto, page = 1) => `${STOCK_API}/transacciones/producto/${idProducto}/${page}`
};

export const CONFIG = {
    layout: 'vertical', // disable on free version
    subLayout: '', // disable on free version
    collapseMenu: true, // mini-menu
    layoutType: 'menu-dark', // disable on free version
    navIconColor: false, // disable on free version
    headerBackColor: 'header-default', // disable on free version
    navBackColor: 'navbar-default', // disable on free version
    navBrandColor: 'brand-default', // disable on free version
    navBackImage: false, // disable on free version
    rtlLayout: false, // disable on free version
    navFixedLayout: true, // disable on free version
    headerFixedLayout: false, // disable on free version
    boxLayout: false, // disable on free version
    navDropdownIcon: 'style1', // disable on free version
    navListIcon: 'style1', // disable on free version
    navActiveListColor: 'active-default', // disable on free version
    navListTitleColor: 'title-default', // disable on free version
    navListTitleHide: false, // disable on free version
    configBlock: true, // disable on free version
    layout6Background: 'linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)', // disable on free version
    layout6BackSize: '' // disable on free version
};
